import { useState } from "react";
import { Button } from "../../ui/button"; // shadcn/ui button
import { LoginBox } from "./Login";

/**
 * Authenticate Component
 * @param {React.Component} SignUpComponent - The sign up form/component to render
 */
export function Authenticate({ SignUpComponent, defaultView = 'login' }) {
  const [view, setView] = useState(defaultView); // "login" | "signup"

  if (view === "signup") {
    // Wipe everything and show only the signup form
    return SignUpComponent ? <SignUpComponent /> : <div>No signup form provided.</div>;
  }

  // Default login layout
  return (
    <div className="mt-8 flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md">
        {/* Title + Description */}
        <div className="text-center space-y-2">
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900">
            Authenticate
          </h1>
          <p className="text-sm sm:text-base text-gray-600">
            Sign in to your account and continue where you left off.
          </p>
        </div>

        {/* Login Form + Switch */}
        <div className="mt-4 space-y-6">
          <LoginBox className="flex justify-center" />
          <div className="text-center">
            <p className="text-gray-600 text-sm mb-3">
              Don’t have an account?
            </p>
            <Button
              variant="secondary"
              className="w-1/2 mx-auto"
              onClick={() => setView("signup")}
            >
              Create an account
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
